import { LoanRequestStatus } from "./customer.model";
import { PaginationInfo as GetInProcessLoansPagination } from "./settlement.model";
export class RegisterLoanBySupplierRequest {
  loanTemplateId: any | undefined;
  customerNationalCode: string | undefined;
  customerBirthDate: string | Date | undefined;
  customerMobileNumber: string | undefined;
  loanAmount: any | undefined;
  postalCode: string | undefined;
  installmentCount: any;
  installmentStepSpace: any | undefined;
  inquiryOtp?: string | undefined;
  inquiryOtpRefKey?: string | undefined;
}
export interface RegisterLoanBySupplierResponse {
  isValid: boolean;
  referenceKey?: string;
  validationIssues: string[];
  customerInfo: CustomerInfo;
  inquiryOtpRequired?: boolean;
  inquiryOtpRefKey?: string;
}
export class GetCustomerRegistrationInfoRequest {
  nationalCode: string | undefined;
}
export interface GetCustomerRegistrationInfoResponse {
  hasRegisterRequest: boolean;
  isEditable: boolean;
  isCancelable: boolean;
  customerInfo: CustomerInfo;
  loanTemplateInfos: LoanTemplateInfo[];
  existingLoanRequest: ExistingLoanRequest;
}
export class CustomerInfo {
  id?: number;
  nationalCode?: string;
  cellPhone?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  fatherName?: string;
  birthDate?: Date;
  birthDatePersian?: string;
  birthDate_Persian?: string;
  genderTypeId?: number;
  email?: string;
  postalCode?: string;
  address?: string;
  cityId?: string;
  idSeri?: number;
  idSerial?: number;
  installmentCount?: number;
  gender?: string;
  hasAccount?: boolean;
}
export interface LoanTemplateInfo {
  isBySupplierCredit: boolean;
  id: number;
  financialSupplierName: string;
  financialSupplierTitle: string;
  expirationDate: Date;
  expirationDate_Persian: string;
  title: string;
  minAmount: number;
  maxAmount: number;
  profitPercentage: number;
  description: string;
  installmentStep: InstallmentStep[];
  supplierCredit: number;
  cardImage: string;
  registrationRequestId: number;
}
export interface InstallmentStep {
  stepSpaceByMonth: number;
  installmentCount: number;
  key: string;
}
export interface ExistingLoanRequest {
  loanRequestId: number;
  loanTemplateId: number;
  finalLoanAmount: number;
  finalStepSpaceByMonth: number;
  finalInstallmentCount: number;
  referenceKey: string;
  loanRequestStatus: string;
}

export class ReferenceKeyRequest {
  referenceKey: string | undefined;
  activationOtp?: string | undefined;
}

export interface ActivateLoanRequestBySupplierResponse {
  isValid: boolean;
  loanRequestId: number;
  validationIssues: string[];
}
export class GetSupplierAttachmentsRequest {
  id: number | undefined;
}

// export interface GetSupplierAttachmentsResponse {
//   fileId: string;
//   fileName: string;
//   documentType: string;
//   fileType: string;
//   fileUrl: string;
//   documentTypeTitle:string;
// }

export interface UploadSupplierAttachmentResponse {
  fileId: string;
  fileName: string;
  documentType: string;
  fileType: string;
  fileUrl: string;
  documentTypeTitle: string;
}
export class DeleteSupplierAttachmentRequest {
  loanRequestId: number | undefined;
  fileAttachmentId: string | undefined;
}

export class UploadSupplierAttachmentRequest {
  LoanRequestId: number | undefined;
  DocumentType: string | undefined;
  FileName: string | undefined;
  FileData: File | undefined;
  FactorNumber: string | undefined;
}

export class GetLoanDetailRequest {
  id: number | undefined;
}
export interface SearchLoanRequestsResponse {
  isEditable: boolean;
  loanRequestId: number;
  customerFirstName: string;
  customerLastName: string;
  customerFullName: string;
  customerAddress: string;
  customerPostalCode: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  supplierName: string;
  factorNumber: string;
  requestDatePersian: string;
  settlementDatePersian: string;
  bankApproveDatePersian: string;
  installmentCount: number;
  installmentAmount: number;
  loanAmount: number;
  profitRate: number;
  loanRequestStatus: string;
  loanRequestStatusTitle: string;
  supplierSettlementStatus: string;
  supplierSettlementStatusTitle: string;
  birthDatePersian: string;
  loanRequestStatusColor: string;
  supplierSettlementStatusColor: string;
  loanTemplateId: number;
  loanTemplateTitle: string;
  referenceKey: string;
  loanRequestSourceTitle: string;
  supplierUserTitle: string;
  supplierUserId: number;
  financialSupplierTitle: string;
  supplierMobileNumber: string;
  loanRequestStatusUpdateDate: string;
  loanRequestStatusUpdateDatePersian: string;
  bankReferenceCode: string;
}
export class SearchLoanRequestsRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}
export class SearchLoanRegisterRequestsRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: FilterRegister | undefined;
}
export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
  rowNumber: number | undefined;
}
export class Filter {
  loanRequestId: number | undefined;
  customerNationalCode: string | undefined;
  customerFullName: string | undefined;
  referenceKey: string | undefined;
  requestDate: string | undefined;
  requestDateTo: string | undefined;
  requestDateFrom: string | undefined;
  loanRequestStatus: string[] | undefined;
  supplierIds: string[] | undefined;
  supplierName: string[] | undefined;
  supplierSettlementStatus: string[] | undefined;
  loanTemplateIds: string[] | undefined;
  loanRequestSources: string[] | undefined;
  supplierUserIds: string[] | undefined;
  customerMobileNumber: string | undefined;
  settlementStatusDateFrom: string | undefined;
  settlementStatusDateTo: string | undefined;
  requestDatePersian: string | undefined;
  settlementStatusDatePersian: string | undefined;
  requestDateArray: Date[] | null | undefined;
  settlementStatusDateArray: Date[] | null | undefined;
  cartableTitle?: string;
  valueLoanTemplate: string[] | undefined;
  sayadNumber?: string | undefined;
  organizationId?: string[] | undefined;
  financialSupplierIds?: number[];
  bankReferenceCode?: string | undefined;
}
export class FilterRegister {
  loanRequestId: number | undefined;
  customerNationalCode: string | undefined;
  customerFullName: string | undefined;
  referenceKey: string | undefined;
  requestDateFrom: string | undefined;
  requestDateTo: string | undefined;
  loanRequestStatus: string[] | undefined;
  supplierSettlementStatus: string[] | undefined;
  loanTemplateIds: string[] | undefined;
  loanRequestSources: string[] | undefined;
  supplierUserIds: string[] | undefined;
  customerMobileNumber: string | undefined;
  statusDateFrom: string | undefined;
  statusDateTo: string | undefined;
  requestDatePersian: string | undefined;
  statusDatePersian: string | undefined;
  requestDateArray: Date[] | null | undefined;
  statusDateArray: Date[] | null | undefined;
  cartableTitle?: string;
  valueLoanTemplate: string[] | undefined;
}
export interface CancelLoanRequestBySupplierRequest {}
// todo new
export class GetLoanInfoRequest {
  customerNationalCode: string | undefined;
  loanRequestId?: number | undefined;
  referenceKey?: string | undefined;
}
export class GetLoanInfoResponse {
  loanAbstractInfo: LoanAbstractInfo | undefined;
  customerInfo: CustomerInfo | undefined;
  contactInfo: ContactInfo | undefined;
  incomeInfos: IncomeInformation[] | undefined;
  chequeGuarantyInfos?: ChequeGuarantyInfo[] | undefined;
  payrollDeductionGuarantyInfos?: PayrollDeductionGuarantyInfo[] | undefined;
  inquiryInfos: InquiryInfo[] | undefined;
  supplierSettlementInfos: SupplierSettlementInfo[] | undefined;
}
export interface PayrollDeductionGuarantyInfo {
  employer: string;
  letterNumber: string;
  letterPersianDate: string;
  creditAmountRial: number;
  expirePersianDate: string;
  documents: Document[];
}
export interface ChequeGuarantyInfo {
  bank: string;
  branch: string;
  duePersianDate: string;
  owner: string;
  amountRial: number;
  sayadNumber: string;
  serial: string;
  seri: string;
  iban: string;
  documents?: Document[];
}
export interface IncomeInformation {
  incomeTitle: string;
  jobTitle: string;
  employer: string;
  phoneNumber: string;
  income: number;
  address: number;
  documents?: Document[];
}
export interface Document {
  documentUrl: string;
  documentThumbnailUrl: string;
}
export interface LoanAbstractInfo {
  loanTemplate: string;
  loanAmount: number;
  instalmentAmount: number;
  instalmentsCount: number;
  instalmentsStep: number;
  firstInstalmentPersianDate: string;
  profitRate: number;
}

// export interface CustomerInfo {
//   fullName: string;
//   nationalCode: string;
//   shenasnameCode: string;
//   fatherName: string;
//   birthPersianDate: string;
//   genderTitle: string;
//   documents: Document[];
// }
//up there

export interface ContactInfo {
  mobileNumber: string;
  phoneNumber: string;
  postalCode: string;
  province: string;
  city: string;
  address: string;
  inquiredAddress: string;
}

export interface InquiryInfo {
  inquiryTitle: string;
  approved: boolean;
  description?: any;
  inquiryPersianDate: string;
}

export interface SupplierSettlementInfo {
  user: string;
  newState: string;
  stateChangeDate: string;
  description: string;
}
export interface GetLoanTemplatesForSetadResponse {
  id: number;
  title: string;
  enumData: string;
  maxSize_KB: number;
}

export class GetInstallmentTableRequest {
  appReferenceKey: string | undefined;
  coreReferenceKey: string | undefined;
  loanRequestId: number | undefined;
  cartableTitle: string | undefined;
}

export interface GetInstallmentTableResponse {
  accumulativeLoaded: boolean;
  status: string;
  color: string;
  cheque: Cheque;
  referenceKey: string;
  installments: installments[];
}

export interface Cheque {
  referenceKey: string;
  chequeId: number;
  amount: number;
  amountAlphabet: string;
  dueDate: string;
  dueDatePersian: string;
  fileId: string;
  chequeType: string;
  expectedHolder: string;
  expectedIdCode: string;
  isAccumulative: true;
  accumulativeAmount: number;
  inquiryAmount: number;
  sayadNumber: string;
  signer: string;
  idCode: string;
  serialNo: string;
  seriesNo: string;
  fromIban: string;
  branchCode: string;
  bankCode: string;
  bankName: string;
  file: UploadSupplierAttachmentResponse;
  inquiryDueDatePersian: string;
}
export interface installments {
  dueDate: string;
  dueDate_Persian: string;
  rowNumber: number;
  amount: number;
  chequeId: number;
  chequeDueDate: string;
  chequeAmount: number;
  headerId: number;
  mainAmount: number;
  profitAmount: number;
  penaltyAmount: number;
  paymentDate: string;
  paymentDatePersian: string;
  repaymentStatus: string;
  repaymentStatusTitle: string;
  gatewayName: string;
  loanTemplateTitle: string;
  penaltyDays: number;
  totalPaidAmount: number;
}

export interface GetLegacyContractsResponse {
  subProtocolTitle: string;
  contractNumber: string;
  noteContractNumber: string;
  contractDate: string;
  loanAmount: number;
  instalmentCount: number;
  instalmentDistance: number;
  firstInstalmentDate: string;
}

export interface DoLoanActionRequest {
  referenceKey: string;
  command: string;
  fields: {
    name: string;
    value: string;
  }[];
}

export interface CancelLoanRequest {
  referenceKey: string;
  cancellationReasons?: number[];
  description?: string;
}

export interface GetCancellationReasonsResponse {
  id: number;
  title: string;
}

export interface GetInProcessLoansRequest {
  paginationInfo?: GetInProcessLoansPagination;
  filter?: GetInProcessLoansFilter;
}

export interface GetInProcessLoansFilter {
  fullName?: string;
  nationalCode?: string;
  mobileNumber?: string;
  loanTemplateIds?: number[];
  organizationIds?: number[];
  loanRequestStatuses?: LoanRequestStatus[];
}

export interface GetInProcessLoansResponse {
  referenceKey: string;
  customerFullName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  loanTemplateTitle: string;
  organizationTitle: string;
  financialSupplierTitle: string;
  stepSpaceByMonth: number;
  installmentCount: number;
  lastUpdateStatusDate: string;
  lastUpdateStatusDate_Persian: string;
  loanRequestStatusId: LoanRequestStatus;
  loanRequestStatusTitle: string;
}
